import type { ICellRendererParams } from 'ag-grid-community';
import { selectProperty } from 'features/property/redux/selectors';
import { useUser } from 'features/users/context/userContext';
import { useAppSelector } from 'redux/hooks';
import { formattedCurrency } from './tableCustomCellRender';

type RateCellProps = {
	params: ICellRendererParams;
	digitFormatter: (value: number | string) => string;
};

export const RateCellRender = ({ params, digitFormatter }: RateCellProps) => {
	const property = useAppSelector(selectProperty);
	const { currencyCode } = property;
	const { locale } = useUser();

	if (params.value) {
		return (
			<span>
				{formattedCurrency(
					params.value,
					locale,
					currencyCode,
					true,
					digitFormatter,
				)}
			</span>
		);
	}
	return <span>{params.value}</span>;
};
